import "./notifications.css";
import NotificationsAll from "./NotificationsTabs/NotificationsAll";

const NotificationsPage = () => {
    return <NotificationsAll />;
};

export default NotificationsPage;
